/* ── Centralized analytics helper ── */

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    fbq?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

function gtag(...args: any[]) {
  window.gtag?.(...args);
}

function fbq(...args: any[]) {
  window.fbq?.(...args);
}

/* ── Public tracking API ── */

export const analytics = {
  /** GA4: custom event */
  event(name: string, params?: Record<string, any>) {
    gtag("event", name, params);
  },

  /** GA4 page_view (fired automatically, but useful for SPA route changes) */
  pageView(path?: string) {
    gtag("event", "page_view", { page_path: path ?? window.location.pathname });
  },

  /** Transform started */
  transformStarted(persona: string, intensity: number) {
    gtag("event", "transform_started", { persona, intensity });
  },

  /** Transform completed */
  transformCompleted(persona: string, intensity: number) {
    gtag("event", "transform_completed", { persona, intensity });
  },

  /** Download clicked */
  downloadClicked() {
    gtag("event", "download_clicked");
  },

  /** Share clicked */
  shareClicked(method: string) {
    gtag("event", "share_clicked", { method });
  },

  /** Upgrade clicked */
  upgradeClicked(tier: string) {
    gtag("event", "upgrade_clicked", { tier });
  },

  /* ── Google Ads conversion ── */
  adsConversion(label: string) {
    gtag("event", "conversion", {
      send_to: `AW-17067733337/${label}`,
    });
  },

  /* ── Meta Pixel events ── */
  metaLead() {
    fbq("track", "Lead");
  },

  metaInitiateCheckout() {
    fbq("track", "InitiateCheckout");
  },

  metaPurchase(value?: number, currency = "USD") {
    fbq("track", "Purchase", { value, currency });
  },
};
